import { observer } from 'mobx-react';

import heroBgGirlImg from '../../../assets/header/hero-bg-girl.png';
import heroBgManImg from '../../../assets/header/hero-bg-man.png';
import { useFlag } from '../../../services/launchDarkly';
import type { CoinType } from '../../../stores/cointype/CoinTypeStore';
import { useStores } from '../../../stores/useStores';
import BackgroundPattern from '../../backrounds/BackgroundPattern';
import newStyles from '../GamesHero.module.scss';
import oldStyles from '../GamesHeroOldSearch.module.scss';

const srcMap = new Map<CoinType, string>([
  ['GC', heroBgGirlImg],
  ['SC', heroBgManImg],
]);

export const CasinoHeader = observer(function CasinoHeader() {
  const { coinTypeStore } = useStores();
  const isOldSearchMode = useFlag('enable_old_search_mode', false);
  const styles = isOldSearchMode ? oldStyles : newStyles;

  const bannerImage = srcMap.get(coinTypeStore.coinType);

  return (
    <BackgroundPattern color={coinTypeStore.coinType === 'GC' ? 'yellow' : 'green'}>
      <div className={styles.casinoHero}>
        <img key="GC" alt="banner" className={styles.gamesHeroImage} src={bannerImage} />
      </div>
    </BackgroundPattern>
  );
});
